<template>
  <div>
    <section class="content-header">
      <h1>{{$t('product.list')}}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-header with-border">
          <router-link :to="{ name: 'ProductCreate' }" class="btn btn-primary pull-right">{{$t('product.add')}}</router-link>
          <button type="button" class="btn btn-info pull-right" @click="generatePdf()" style="margin-right: 10px;">{{ $t('generate_pdf') }}</button>
          <button type="button" class="btn btn-warning pull-right" @click="createEmailTemplate()" style="margin-right: 10px;">Create email template</button>
        </div>
        <div class="box-body">
          <item-list-errors :entity="'product'"></item-list-errors>

          <api-table
              :entity="'Product'"
              :route="'products'"
              :path="'product'"
              :filterable="filterable"
              :customFilters="customFilters"
              :sortable="sortable"
              :columns="columns"
              :columnsClasses="columnsClasses"
              :templates="templates"
              :rowClassCallback="rowClassCallback"
          >
            <template slot="filter__category.id">
              <category-filter></category-filter>
            </template>
          </api-table>
        </div>
      </div>
    </section>
    <modal-create-template></modal-create-template>
  </div>
</template>

<script>
  import ItemListErrors from '../layout/errors/ItemListErrors'
  import ApiTable from '../ApiTable'
  import columnCategoryTranslatedName from './../../table/ColumnCategoryTranslatedName'
  import columnPriceBuy from './../../table/ColumnPriceBuy'
  import columnPriceSell from './../../table/ColumnPriceSell'
  import columnCompanyCode from './../../table/ColumnCompanyCode'
  import CategoryFilter from "../filters/CategoryFilter";
  import ModalCreateTemplate from './ModalCreateTemplate'
  import axios from '../../interceptor'

  export default {
    components: {ModalCreateTemplate, CategoryFilter, ItemListErrors, ApiTable},
    data: function () {
      return {
        columns: ['columnCompanyCode', 'id', 'name', 'category.id', 'age', 'columnPriceBuy', 'columnPriceSell', 'availability', 'actions'],
        filterable: ['columnCompanyCode', 'id', 'name', 'age', 'columnPriceBuy', 'columnPriceSell', 'availability'],
        customFilters: ['category.id'],
        sortable: [],
        columnsClasses: {'company.code': 'product-code', id: 'product-id'},
        templates: {
          columnCategoryTranslatedName,
          columnPriceBuy,
          columnPriceSell,
          columnCompanyCode,
          'category.id': columnCategoryTranslatedName,
        },
        rowClassCallback: (row) => {
          if (!row.isActive) {
            return 'row-blue'
          }

          if (row.status && row.status.id === 3) {
            return 'row-red'
          }

          if (row.status && row.status.id === 2) {
            return 'row-yellow'
          }
        }
      }
    },
    methods: {
      createEmailTemplate () {
        $('#modal-create-template').modal('show')
      },
      generatePdf() {
        axios.request({
          url: process.env.API_URL + '/products/price-list/pdf',
          method: 'GET',
          responseType: 'blob', // important
        }).then(response => {
          this.$toastr.s(this.$t('pdf_successfully_generated'))

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'price-list-' + (new Date()).toISOString() + '.pdf');
          document.body.appendChild(link);
          link.click();
        }).catch(() => {
          this.$toastr.e(this.$t('pdf_generate_error'))
        })
      }
    }
  }
</script>

<style>
  #list-table .row-red {
    background-color: #fad5d4;
  }
  #list-table .row-blue {
    background-color: #d4dcfa;
  }
  #list-table .row-yellow {
    background-color: #faf0d4;
  }
</style>
